import React from "react";
import { Box, Button, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import LeadersList from "./LeadersList";

const useStyles = makeStyles(theme => ({
  groupType: {
    textTransform: "capitalize"
  },
  chartWrapper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    border: `${theme.palette.secondary[300]} solid 1px`,
    borderRadius: "2.5px",
    width: "100%"
  }
}));

export default function Leaders({
  groupType,
  groupTypeValue,
  averageScore,
  leaders,
  onViewAllClicked
}) {
  const classes = useStyles();
  return (
    <Box
      display="flex"
      flexDirection="column"
      m={2.5}
      justifyContent="flex-start"
      height="100%"
    >
      <Box
        display="flex"
        justifyContent="space-between"
        width="100%"
        flexWrap="wrap"
      >
        <Typography
          variant="body1"
          color="textSecondary"
          className={classes.groupType}
        >
          {groupType}
        </Typography>
        <Typography variant="subtitle1">{groupTypeValue}</Typography>
      </Box>
      <Box className={classes.chartWrapper}>
        <Box
          width="100%"
          mx={1.5}
          my={2}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box width="100%" mr={1}>
            <ProgressBar
              color="primary"
              completedSteps={averageScore}
              totalSteps={100}
              segmented
            />
          </Box>
          <Typography variant="caption" color="textSecondary">
            {`${averageScore}%`}
          </Typography>
        </Box>
      </Box>
      <Box width="100%">
        <Typography variant="subtitle1">Award Leaders</Typography>
      </Box>
      <LeadersList leaders={leaders ? leaders.slice(0, 2) : null} />
      <Box mt={3} display="flex" justifyContent="center">
        <Button color="primary" onClick={onViewAllClicked}>
          View All
        </Button>
      </Box>
    </Box>
  );
}
